import { defineComponent as _defineComponent } from 'vue'
import { generate_uid } from "@/utils";
import { computed, reactive } from "vue";

interface PropTypes {
  start_open?: boolean;
  include_caret?: boolean;

  // When true, this collapsible will stay open even when clicked on.
  // Once this value becomes false, it will be able to close again.
  stay_open?: boolean;

  // When true, the collapsible's header panel will be highlighted to
  // indicate that it is active.
  is_active?: boolean;

  // Used to configure styling of the collapsible's header panel indentation level.
  // Note that it does not affect the indentation of the collapsible's
  // body.
  // Valid values are null and the numbers 0, 1, 2, and 3.
  // Note that indentation level 0 adds a small amount of visual left padding,
  // while null adds no left padding.
  indentation_level?: number | null;

  // When true, the header_icons_slot will always be visible.
  // When false, the header_icons slot will only be visible when the user
  // hovers over the header panel or when this.is_active is true.
  always_show_icons?: boolean;

  // When true, the body of the collapsible will be wrapped
  // in a v-if instead of v-show.
  use_v_if?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleContent',
  props: {
    start_open: { type: Boolean, default: false },
    include_caret: { type: Boolean, default: true },
    stay_open: { type: Boolean, default: false },
    is_active: { type: Boolean, default: false },
    indentation_level: { default: 0 },
    always_show_icons: { type: Boolean, default: false },
    use_v_if: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { start_open: boolean, include_caret: boolean, stay_open: boolean, is_active: boolean, indentation_level: number | null, always_show_icons: boolean, use_v_if: boolean };



const state = reactive({
  is_open: props.start_open,
});

function toggle_is_open() {
  if (state.is_open && !props.stay_open) {
    state.is_open = false;
  } else {
    state.is_open = true;
  }
}

const body_id = computed(() => {
  return `collapsible-body-${generate_uid()}`;
});

expose({
  state,
  toggle_is_open,
});

return { __sfc: true,props, state, toggle_is_open, body_id }
}

})